import Vue from "vue";
import Router from "vue-router";
// import BlankView from "../layout/BlankView.vue";
Vue.use(Router);
const routes = [
  {
    path: "",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "登录页",
    component: () => import("../pages/login/index.vue"),
    meta: {
      title: "登录页",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },
  {
    path: "/addLogin",
    name: "登录页",
    component: () => import("../pages/login/addLogin.vue"),
    meta: {
      title: "登录页",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },
  {
    path: "/whitePage/login",
    name: "登录页",
    component: () => import("../pages/whitePage/login/index.vue"),
    meta: {
      title: "登录页",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },
   {
    path: "/whitePage/TouristBind",
    name: "游客绑定",
    component: () => import("../pages/whitePage/TouristBind/index.vue"),
    meta: {
      title: "游客绑定",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },
  {
    path: "/whitePage/Report",
    name: "体测报告",
    component: () => import("../pages/whitePage/Report/index.vue"),
    meta: {
      title: "体测报告",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },
   {
    path: "/whitePage/dinfo",
    name: "设备信息",
    component: () => import("../pages/whitePage/dinfo/index.vue"),
    meta: {
      title: "设备信息",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },

  
    {
    path: "/instructions",
    name: "使用说明",
    component: () => import("../pages/whitePage/instructions/index.vue"),
    meta: {
      title: "使用说明",
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    }
  },

    // 家长端路由组
    {
      path: '/parent',
      redirect: '/parent/home',
      component: () => import('@/layout/ParentLayout.vue'),
      children: [
        {
          path: "/parentHomePage",
          name: "家长端首页",
          component: () => import("../pages/parentHomePage/index.vue"),
          meta: {
            title: "家长端首页",
            authority:'*',
            notGetUserInfo: true
          }
        },
        {
          path: "/parentCenter",
          name: "家长端个人中心",
          component: () => import("../pages/parentCenter/index.vue"),
          meta: {
            title: "家长端个人中心",
            authority:'*',
            notGetUserInfo: true
          }
        },

         {
          path: "/parentCenter/NationalPhysicalStandards",
          name: "国际体测标准",
          component: () => import("../pages/parentCenter/NationalPhysicalStandards.vue"),
          meta: {
            title: "国际体测标准",
          }
        },
        {
          path: "/parentCenter/CheatingRules",
          name: "作弊规则",
          component: () => import("../pages/parentCenter/CheatingRules.vue"),
          meta: {
            title: "作弊规则",
          }
        },

        {
          path: "/sportStar",
          name: "运动之星",
          component: () => import("../pages/sportStar/index.vue"),
          meta: {
            title: "运动之星",
            authority:'*',
            notGetUserInfo: true
          }
        },
     
        {
          path: "/integralShop/shop",
          name: "积分商城",
          component: () => import("../pages/integralShop/shop.vue"),
          meta: {
            title: "积分商城",
          }
        },


      ]
    },
    {
      path: "/webpage",
      name: "首页",
      component: () => import("../pages/webpage"),
      meta: {
        title: "中小学体育服务平台",
        authority:'*',
        notGetUserInfo: true
      }
    },
    {
      path: "/integralShop",
      name: "积分商城",
      component: () => import("../pages/integralShop/shop.vue"),
      meta: {
        title: "积分商城",
      }
    },
  // {
  //   path: "/webpage",
  //   name: "首页",
  //   component: () => import("../pages/webpage"),
  //   meta: {
  //     title: "中小学体育服务平台",
  //     authority:'*',
  //     notGetUserInfo: true
  //   }
  // },
  {
    path: "/index",
    name: "首页",
    component: () => import("../pages/index"),
    meta: {
      title: "中小学体育服务平台",
      authority:'*',
      notGetUserInfo: true
    }
  },
  
  {
    path: "/guidePage",
    name: "首次注册",
    component: () => import("../pages/guidePage/index.vue"),
    meta: {
      title: "首次注册",
    }
  },
  // {
  //   path: "/admissionGuide",
  //   name: "电子准考证",
  //   component: () => import("../pages/guidePage/admissionGuide.vue"),
  //   meta: {
  //     keepAlive:true,
  //     title: "电子准考证",
  //   }
  // },
  {
    path: "/addAdmissionGuide",
    name: "新建准考证",
    component: () => import("../pages/guidePage/addAdmissionGuide.vue"),
    meta: {
      title: "新建准考证",
    }
  },

  
  {
    path: "/parentReg",
    name: "信息登记",
    component: () => import("../pages/register/parentReg.vue"),
    meta: {
      title: "信息登记",
      authority:'*',
      notGetUserInfo: true
    }
  },
  {
    path: "/personalInfo",
    name: "个人信息",
    component: () => import("../pages/personalInfo/index.vue"),
    meta: {
      title: "个人信息",
    }
  },
  {
    path: "/studentBind",
    name: "学生绑定",
    component: () => import("../pages/studentBind/index.vue"),
    meta: {
      title: "学生绑定",
    }
  },
  {
    path: "/addStudent",
    name: "学生绑定",
    component: () => import("../pages/studentBind/addStudent.vue"),
    meta: {
      title: "学生绑定",
    }
  },
  
  {
    path: '/messageBoardMgt',
    name: '留言板',
    component: () => import('../pages/messageBoardMgt')
  },
   {
    path: '/teacherAttendanceCall',
    name: '教师考勤点名',
    component: () => import('../pages/teacherAttendanceCall')
  },
  {
    path: "/admissionTicket",
    name: "电子测训准考证",
    component: () => import("../pages/admissionTicket/index.vue"),
    meta: {
      title: "电子测训准考证",
    }
  },
  
  {
    path: "/addFaceIn",
    name: "新建电子测训准考证",
    component: () => import("../pages/admissionTicket/addFaceIn.vue"),
    meta: {
      title: "新建电子测训准考证",
    }
  },
  
  {
    path: "/aiFace",
    name: "拍摄证件照",
    component: () => import("../pages/admissionTicket/aiFace.vue"),
    meta: {
      title: "拍摄证件照",
    }
  },
  {
    path: "/appointment",
    name: "预约与查询",
    component: () => import("../pages/appointment/index.vue"),
    meta: {
      title: "预约与查询",
    }
  },
  
  {
    path: "/addTest",
    name: "预约测试",
    component: () => import("../pages/appointment/addTest.vue"),
    meta: {
      title: "预约测试",
    }
  },
  
  {
    path: "/testTrainingReport",
    name: "测训报告",
    component: () => import("../pages/testTrainingReport/index.vue"),
    meta: {
      title: "测训报告",
    }
  },
  {
    path: "/fitnessReportV2",
    name: "运动分析",
    component: () => import("../pages/fitnessReport/indexV2.vue"),
    meta: {
      title: "运动分析",
    }
  },
  
  {
    path: "/fitnessReport",
    name: "体测报告",
    component: () => import("../pages/fitnessReport/index.vue"),
    meta: {
      title: "体测报告",
    }
  },
   {
    path: "/projectLogBoard",
    name: "项目分析报告",
    component: () => import("../pages/projectLogBoard/index.vue"),
    meta: {
      title: "项目分析报告",
    }
  },
  
  {
    path: "/AIConversation",
    name: "龙猫AI健康咨询",
    component: () => import("../pages/AIConversation/index.vue"),
    meta: {
      title: "龙猫AI健康咨询",
    }
  },
  {
    path: "/fitnessAnalysis",
    name: "体测报告",
    component: () => import("../pages/fitnessReport/fitnessAnalysis/index.vue"),
    meta: {
      title: "体测报告",
    }
  },
  {
    path: "/whiteBook",
    name: "体测数据看板",
    component: () => import("../pages/teacher/whiteBook/index.vue"),
    meta: {
      title: "体测数据看板",
    }
  },
  
  
    {
    path: "/videoMgt",
    name: "视频管理",
    component: () => import("../pages/videoMgt/index.vue"),
    meta: {
      title: "视频管理",
    }
  },
  {
    path: "/resultReporting",
    name: "家长自测",
    component: () => import("../pages/resultReporting/index.vue"),
    meta: {
      title: "家长自测",
    }
  },
  {
    path: "/reportingList",
    name: "体测成绩登记",
    component: () => import("../pages/resultReporting/reportingList.vue"),
    meta: {
      title: "体测成绩登记",
    }
  },
  {
    path: "/scoreInfo",
    name: "成绩详情",
    component: () => import("../pages/resultReporting/scoreInfo.vue"),
    meta: {
      title: "成绩详情",
    }
  },
  {
    path: "/homework",
    name: "家庭作业",
    component: () => import("../pages/homework/index.vue"),
    meta: {
      title: "家庭作业",
    }
  },
  {
    path: "/homeworkInfo",
    name: "家庭作业详情",
    component: () => import("../pages/homework/homeworkInfo.vue"),
    meta: {
      title: "家庭作业详情",
    }
  },
  
  {
    path: "/bodyForging",
    name: "体育锻炼报告",
    component: () => import("../pages/bodyForging/index.vue"),
    meta: {
      title: "体育锻炼报告",
    }
  },
  {
    path: "/surveyMgt",
    name: "健康信息申报",
    component: () => import("../pages/surveyMgt/index.vue"),
    meta: {
      title: "健康信息申报",
    }
  },
  {
    path: "/sunrunScore",
    name: "阳光跑成绩",
    component: () => import("../pages/sunrun/score/home.vue"),
    meta: {
      title: "阳光跑成绩",
    }
  },
    {
    path: "/surveyMgtInfo",
    name: "健康信息申报",
    component: () => import("../pages/surveyMgt/info.vue"),
    meta: {
      title: "健康信息申报",
    }
  },
  
  
// 教师


{
  path: "/teacher",
  name: "教师首页",
  component: () => import("../pages/teacher/index.vue"),
  meta: {
    title: "教师首页",
  }
},

{
  path: "/informationCenterTeacher",
  name: "个人信息中心（教师）",
  component: () => import("../pages/teacher/informationCenterTeacher/index.vue"),
  meta: {
    title: "个人信息中心（教师）",
  }
},
{
  path: "/addTeacher",
  name: "新增教师",
  component: () => import("../pages/teacher/addTeacher/index.vue"),
  meta: {
    title: "新增教师",
  }
},

{
  path: "/ReportManagement",
  name: "举报记录",
  component: () => import("../pages/teacher/ReportManagement.vue"),
  meta: {
    title: "举报记录",
  }
},
{
  path: "/AuditCenter",
  name: "审核中心",
  component: () => import("../pages/teacher/AuditCenter.vue"),
  meta: {
    title: "审核中心",
  }
},
{
  path: "/RaceCommandManager",
  name: "长跑发令",
  component: () => import("../pages/teacher/RaceCommandManager.vue"),
  meta: {
    title: "长跑发令",
  }
},
{
  path: "/PETeacherWorkspace",
  name: "测试场景",
  component: () => import("../pages/teacher/PETeacherWorkspace.vue"),
  meta: {
    title: "测试场景",
  }
},

{
  path: "/teacherReporting",
  name: "成绩查询和登记",
  component: () => import("../pages/teacher/teacherReporting/index.vue"),
  meta: {
    title: "成绩查询和登记",
  }
},
{
  path: "/powerSwitch",
  name: "设备电源开关",
  component: () => import("../pages/teacher/powerSwitch/index.vue"),
  meta: {
    title: "设备电源开关",
  }
},

{
  path: "/deviceControlMgt",
  name: "设备遥控器管理",
  component: () => import("../pages/teacher/deviceControlMgt/index.vue"),
  meta: {
    title: "设备遥控器管理",
  }
},

{
  path: "/deviceControl",
  name: "设备控制",
  component: () => import("../pages/teacher/deviceControl/index.vue"),
  meta: {
    title: "设备控制",
  }
},
{
  path: "/deviceTypeControl",
  name: "设备软件控制",
  component: () => import("../pages/teacher/deviceTypeControl/index.vue"),
  meta: {
    title: "设备软件控制",
  }
},


{
  path: "/deviceControlVideo",
  name: "跳跳视讯切换",
  component: () => import("../pages/teacher/deviceControlVideo/index.vue"),
  meta: {
    title: "跳跳视讯切换",
  }
},

{
  path: "/devicePhoneControl",
  name: "手机遥控器",
  component: () => import("../pages/teacher/devicePhoneControl/index.vue"),
  meta: {
    title: "手机遥控器",
  }
},

{
  path: "/outdoorRunning",
  name: "户外跑设置",
  component: () => import("../pages/teacher/outdoorRunning/index.vue"),
  meta: {
    title: "户外跑设置",
  }
},
{
  path: "/outdoorRunning/outdoorRunningConfig",
  name: "户外跑配置",
  component: () => import("../pages/teacher/outdoorRunning/outdoorRunningConfig.vue"),
  meta: {
    title: "户外跑配置",
  }
},

{
  path: "/outdoorRunning/cloudPlatform",
  name: "户外跑云台设置",
  component: () => import("../pages/teacher/outdoorRunning/cloudPlatform.vue"),
  meta: {
    title: "户外跑云台设置",
  }
},


{
  path: "/outdoorRunning/WiFiCheck",
  name: "户外跑控制端网络检测",
  component: () => import("../pages/teacher/outdoorRunning/WiFiCheck.vue"),
  meta: {
    title: "户外跑控制端网络检测",
  }
},
{
  path: "/outdoorRunning/SelectVenue",
  name: "户外跑控制端场地选择",
  component: () => import("../pages/teacher/outdoorRunning/SelectVenue.vue"),
  meta: {
    title: "户外跑控制端场地选择",
  }
},
{
  path: "/outdoorRunning/DeviceStatus",
  name: "户外跑控制端首页",
  component: () => import("../pages/teacher/outdoorRunning/DeviceStatus.vue"),
  meta: {
    title: "户外跑控制端首页",
  }
},
{
  path: "/outdoorRunning/SelectProject",
  name: "户外跑控制端项目切换",
  component: () => import("../pages/teacher/outdoorRunning/SelectProject.vue"),
  meta: {
    title: "户外跑控制端项目切换",
  }
},
{
  path: "/outdoorRunning/DeviceIssueOrder",
  name: "户外跑控制端发令",
  component: () => import("../pages/teacher/outdoorRunning/DeviceIssueOrder.vue"),
  meta: {
    title: "户外跑控制端项发令",
  }
},




{
  path: "/teacherSunrunScore",
  name: "阳光跑成绩查询",
  component: () => import("../pages/teacher/teacherSunrunScore/index.vue"),
  meta: {
    title: "阳光跑成绩查询",
  }
},

{
  path: "/qrReporting",
  name: "扫描登记",
  component: () => import("../pages/teacher/teacherReporting/qrReporting.vue"),
  meta: {
      title: "扫描登记",
  }
},
{
  path: "/teacherAddFaceIn",
  name: "教师制证",
  component: () => import("../pages/teacher/teacherAddFaceIn/index.vue"),
  meta: {
      title: "教师制证",
  }
},
{
  path: "/teacherAddFaceIn/addFaceInfo",
  name: "教师制证",
  component: () => import("../pages/teacher/teacherAddFaceIn/addFaceInfo.vue"),
  meta: {
      title: "教师制证",
  }
},
{
  path: "/teacherAddFaceIn/addFaceInfoV2",
  name: "教师制证",
  component: () => import("../pages/teacher/teacherAddFaceIn/addFaceInfoV2.vue"),
  meta: {
      title: "教师制证",
  }
},
{
  path: "/teacherAdminFace",
  name: "管理员制证",
  component: () => import("../pages/teacher/teacherAdminFace/index.vue"),
  meta: {
      title: "管理员制证",
  }
},
{
  path: "/test",
  name: "测试页面",
  component: () => import("../pages/teacher/teacherAdminFaceV2/index.vue"),
  meta: {
      title: "测试页面",
  }
},

{
  path: "/classReporting",
  name: "按班级登记",
  component: () => import("../pages/teacher/teacherReporting/classReporting.vue"),
  meta: {
    title: "按班级登记",
  }
},
{
  path: "/teacherScore",
  name: "成绩查询",
  component: () => import("../pages/teacher/teacherScore/index.vue"),
  meta: {
    title: "成绩查询",
  }
},
{
  path: "/whitePage/teacherScore",
  name: "成绩查询大屏",
  component: () => import("../pages/whitePage/teacherScore/index.vue"),
  meta: {
    title: "成绩查询大屏",
    authority:'*',
    notUseWxCode: true, // 不使用微信code
  }
},

{
  path: "/whitePage/whiteBook",
  name: "白皮书查询大屏",
  component: () => import("../pages/whitePage/whiteBook/index.vue"),
  meta: {
    title: "白皮书查询大屏",
    authority:'*',
    notUseWxCode: true, // 不使用微信code
  }
},

{
  path: "/teacherReporting/reportingList",
  name: "成绩登记",
  component: () => import("../pages/teacher/teacherReporting/reportingList.vue"),
  meta: {
    title: "成绩登记",
  }
},

  
  {
    path: "/teacherReg",
    name: "教师信息登记",
    component: () => import("../pages/register/teacherReg.vue"),
    meta: {
      title: "教师信息登记",
      notGetUserInfo: true
    }
  },

  
  {
    path: "/register",
    name: "信息登记",
    component: () => import("../pages/register/index.vue"),
    meta: {
      title: "中小学体育服务平台",
      notGetUserInfo: true
    }
  },
  {
    path: "/registerV2",
    name: "信息绑定",
    component: () => import("../pages/register/registerV2.vue"),
    meta: {
      title: "中小学体育服务平台",
      notGetUserInfo: true
    }
  },
  {
    path: "/registerSuccess",
    name: "信息登记成功",
    component: () => import("../pages/register/success.vue"),
    meta: {
      title: "中小学体育服务平台",
      notGetUserInfo: true
    }
  },

  {
    path: "/:catchAll(.*)",
    name: "500",
    component: () => import("../pages/500.vue"),
    meta: {
      authority:'*',
      notUseWxCode: true, // 不使用微信code
    },
  },
  // {
  //   path: "/studenth5",
  //   name: "龙猫校园体育平台",
  //   component: () => import("@/pages/studenth5/index.vue"),
  //   meta: {
  //     title: "智能体测",
  //     notGetUserInfo: true
  //   }
  // },
  // {
  //   path: "/supermarketh5",
  //   name: "龙猫校园体育平台",
  //   component: () => import("@/pages/supermarketh5/index.vue"),
  //   meta: {
  //     title: "运动超市",
  //     notGetUserInfo: true
  //   }
  // },
  // {
  //   path: "/fitnessh5",
  //   name: "龙猫校园体测平台",
  //   component: () => import("@/pages/fitnessH5/fitnessh5.vue"),
  //   meta: {
  //     title: "运动超市",
  //     notGetUserInfo: true
  //   }
  // },
  // {
  //   path: "/examinerLoginsupermarketh5",
  //   name: "龙猫校园体育平台手机授权",
  //   component: () => import("@/pages/supermarketh5/examiner-login.vue"),
  //   meta: {
  //     title: "运动超市",
  //     notGetUserInfo: true
  //   }
  // }
];

// add route path
routes.forEach(route => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({ mode: "history", routes });
let toURL = null

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
console.log(to, from, next);

  // if (toURL === to.path) {
  //   next()
  // }
  // if (to.path !== from.path) {
  //   toURL = to.path
  //   router.replace(to.path)
  //   next()
  // }



});





export { router };
